import { ALL_AVAILABLE_LANGUAGES, EntityId } from "@jackfruit/common"
import { useApplicationState } from "./useApplicationState"
import { useProductImages } from "./useProductImages"

const defaultLocale = "en-US"

export const useProductGridImage = (productId: EntityId) => {
  const { language } = useApplicationState()
  const { productImages } = useProductImages(productId)

  const mobileImage = productImages.find(image => {
    const productLocale = image?.metaData?.locale || defaultLocale

    if (!ALL_AVAILABLE_LANGUAGES.includes(productLocale)) {
      console.warn(
        `Mobile View Image: Invalid locale ${productLocale} for product ${productId}. List locales: ${ALL_AVAILABLE_LANGUAGES}`
      )
    }

    return productLocale === language && image?.metaData?.web?.mobile?.thumbnail
  })

  const desktopImage = productImages.find(image => {
    const productLocale = image?.metaData?.locale || defaultLocale

    if (!ALL_AVAILABLE_LANGUAGES.includes(productLocale)) {
      console.warn(
        `Desktop View Image: Invalid locale ${productLocale} for product ${productId}. List locales: ${ALL_AVAILABLE_LANGUAGES}`
      )
    }

    return (
      productLocale === language && image?.metaData?.web?.desktop?.thumbnail
    )
  })

  const productMobileImage = mobileImage ?? productImages[0]
  const productDesktopImage = desktopImage ?? productImages[0]

  return {
    productMobileImage,
    productDesktopImage,
  }
}
